import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import WithModal from "Components/withModal";
import classNames from "classnames";
import isNumber from "lodash/isNumber";
import isUndefined from "lodash/isUndefined";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import DocumentEditor from "./documentEditor";
import locale from "./documentEditorPanel.locale";
import mode from "./mode";
export const SIZES = {
    MODAL: {
        [mode.CREATE]: { width: 560, height: 417 },
        [mode.EDIT]: { width: 560, height: 417 },
        [mode.DUPLICATE]: { width: 400, height: 361 }
    }
};
const titleMap = {
    [mode.CREATE]: locale.CREATE_DOCUMENT,
    [mode.EDIT]: locale.EDIT_DOCUMENT,
    [mode.DUPLICATE]: locale.DUPLICATE_DOCUMENT
};
function DocumentEditorPanel(props) {
    const [show, setShow] = useState(false);
    const documentIdRef = useRef(props.documentId);
    const [inEditingProgress, setInEditingProgress] = useState(new Set());
    const title = useMemo(() => (props.mode ? titleMap[props.mode] : ""), [props.mode]);
    const modalSize = useMemo(() => (props.mode ? SIZES.MODAL[props.mode] : { width: 560, height: 417 }), [props.mode]);
    useEffect(() => {
        documentIdRef.current = props.documentId;
        props.documentId && props.onInitialized && props.onInitialized(props.documentId);
        setShow(!isUndefined(props.documentId) && !isUndefined(props.mode));
    }, [props.documentId]);
    const handleHideModal = useCallback((e) => {
        if (e)
            props.onClose && props.onClose();
        else
            setShow(false);
    }, [props.onClose]);
    const handleClose = useCallback((documentId) => {
        if (documentId === documentIdRef.current)
            setShow(false);
    }, []);
    const handleEditingInProgress = useCallback((inProgress, documentId) => {
        setInEditingProgress(prev => {
            if (inProgress && prev.has(documentId))
                return prev;
            const result = new Set(prev);
            if (inProgress)
                result.add(documentId);
            else
                result.delete(documentId);
            return result;
        });
    }, []);
    return (React.createElement(WithModal, { show: show, onHide: handleHideModal, contentClassName: classNames("modal-padding", isNumber(props.documentId) &&
            inEditingProgress.has(props.documentId) &&
            "no-pointer-events"), shadingColor: shadingLightestColor, className: "bg-blur", title: title, defaultWidth: modalSize.width, defaultHeight: modalSize.height, isLoading: props.inProgress },
        React.createElement(DocumentEditor, { onEditingInProgress: handleEditingInProgress, onClose: handleClose, activeNewDocumentAfterCreation: props.activeNewDocumentAfterCreation })));
}
export default memo(DocumentEditorPanel);
